import { render, staticRenderFns } from "./CommonProblem.vue?vue&type=template&id=1ee85b62&scoped=true&"
import script from "./CommonProblem.vue?vue&type=script&lang=ts&"
export * from "./CommonProblem.vue?vue&type=script&lang=ts&"
import style0 from "./CommonProblem.vue?vue&type=style&index=0&id=1ee85b62&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee85b62",
  null
  
)

export default component.exports